import React, { Fragment } from "react";
import TableList from "components/TableList";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment";
import { Row, Col, OverlayTrigger, Tooltip, Popover } from "react-bootstrap";
import isEqual from "lodash/isEqual";
import pickBy from "lodash/pickBy";
import queryString from "query-string";
import Moment from "moment";
import * as ProjectActionType from "Projects/constants";
import * as RegionActionType from "Region-Market/constants";
import * as WorkOrderActionType from "../constants";
import * as AuthActionType from "Auth/constants";
import * as SubcontractorActionType from "../../Subcontractors/constants";
import * as TradeActionType from "../../Trades/constants";
import * as RFSActionType from "Request-Services/constants";
import SubcontractorWorkOrderFilters from "../Components/SubcontractorWorkOrdersFilters";
import BuilderWorkOrderFilters from "../Components/BuilderWorkOrderFilters";
import { AppSettings } from "../../constants";
import * as BuilderActionType from "Builders/constants";
import { ChangeColumn } from "components/change-column";
import Translate from "components/translate";
import EmailPopup from "../Components/EmailPopup";
import { EmailButton } from "../Components/EmailButton";

// import isNumber from 'lodash/isNumber';
import {
  renderAgeOfWorkOrder,
  checkIsOverdueWorkOrder,
  formatTimezoneDateTime,
  initialSizePerPage,
  dispatchActionSetPageSizeReference,
} from "helper/unit-helper";
import { ExportButton } from "../Components/ExportButton";
import { Dropdown } from "components/Dropdown/Dropdown";
import ReassignMultiplePopup from "../Components/ReassignMultiplePopup";
import { CheckBoxSingle } from "components/checkboxes/check-box-single";
import { SortCaret } from "Lots/Components/SortCaret";

const defaultParams = {
  defaultSortName: "refNo",
  defaultSortOrder: "descending",
  sizePerPage: 10,
};

const TABLE_NAME = "WORK_ORDER_LIST";

const getHeaderOptions = () => {
  const options = [
    {
      value: 0,
      text: "Bulk actions",
    },
    {
      value: 1,
      text: "Reassign",
    },
  ];

  return options;
};

class WorkOrderList extends React.Component {
  static propTypes = {
    dispatch: PropTypes.func,
    WorkOrderStore: PropTypes.object,
    SelectListProject: PropTypes.array,
    history: PropTypes.object,
    SelectListRegions: PropTypes.array,
    SelectListMarkets: PropTypes.array,
    SubcontractorList: PropTypes.array,
    UserList: PropTypes.array,
    builderUserList: PropTypes.array,
    UserProfile: PropTypes.object,
    SettingDataGridColumn: PropTypes.object,
    SelectListTrade: PropTypes.array,
    SelectListLots: PropTypes.array,
    location: PropTypes.object,
    PageSizeReference: PropTypes.object,
    SavedFilterList: PropTypes.array,
    SavedFilterValueProfile: PropTypes.object,
    SelectedFilterName: PropTypes.string,
  };

  constructor(props) {
    super(props);

    this.sizePerPage = initialSizePerPage(
      TABLE_NAME,
      props.PageSizeReference,
      props.WorkOrderStore.WorkOrdersList.params.take
    );

    this.queryParams = queryString.parse(this.props.location.search);

    this.state = {
      sizePerPage: this.queryParams.take
        ? Number(this.queryParams.take)
        : this.sizePerPage,
      currentPage: this.queryParams.skip
        ? Number(this.queryParams.skip)
        : props.WorkOrderStore.WorkOrdersList.params.skip,
      totalRecord: props.WorkOrderStore.WorkOrdersList.params.totalRecord,
      defaultSortName: this.queryParams.sortField
        ? this.queryParams.sortField
        : defaultParams.defaultSortName,
      defaultSortOrder: this.queryParams.sortOrder
        ? this.queryParams.sortOrder
        : defaultParams.defaultSortOrder,
      detectInputSearchInterVal: 0,
      builderColumn: [
        {
          field: "refNo",
          header: "WO#",
          isKey: true,
          sort: true,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "number",
          apiField: "RefNo",
          customRender: this.customRenderWOIDSubcontractor.bind(this),
        },
        {
          field: "originalRefNo",
          header: "Legacy ID (v3)",
          hidden: true,
          isKey: false,
          sort: true,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "legacyWO",
          customRender: this.customRenderOriginalRefNoV3.bind(this),
        },
        {
          field: "RFSRefNo",
          header: "RFS#",
          hidden: true,
          isKey: false,
          sort: true,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "number",
          apiField: "RFSRefNo",
          customRender: this.customRenderRFSID.bind(this),
        },
        {
          field: "createdDate",
          header: "Created",
          hidden: true,
          isKey: false,
          sort: true,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "name",
          apiField: "CreatedDate",
          customRender: this.customRenderCreatedDate.bind(this),
        },
        {
          field: "lotName",
          header: (
            <span>
              <Translate translateKey="lot" capitalize /> #
            </span>
          ),
          isKey: false,
          sort: true,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "name",
          apiField: "Lot",
        },
        {
          field: "streetAddress",
          header: "Street address",
          isKey: false,
          sort: false,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "address",
          apiField: "StreetAddress",
        },
        {
          field: "tradeName",
          header: "Trade",
          hidden: true,
          isKey: false,
          sort: true,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "name",
          apiField: "Trade",
        },
        {
          field: "itemRepairDesc",
          header: "Items to repair",
          isKey: false,
          sort: true,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "name",
          apiField: "ItemToRepair",
        },
        {
          field: "assignedTo",
          header: "Assigned to",
          hidden: true,
          isKey: false,
          sort: true,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "name",
          apiField: "Assigned",
          customRender: this.customRenderAssigned.bind(this),
        },
        {
          field: "rfsManagedBy",
          header: "Managed by",
          hidden: true,
          isKey: false,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "name",
          apiField: "RFSManagedBy",
        },
        {
          field: "appointmentDate",
          header: "Appointment",
          hidden: false,
          isKey: false,
          sort: true,
          dataAlign: "left",
          headerAlign: "left",
          apiField: "Appointment",
          customRender: this.customRenderAppointmentDate.bind(this),
          widthStyle: "appointment",
        },
        {
          field: "title",
          header: "Summary",
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderTitle.bind(this),
          widthStyle: "address",
          apiField: "Summary",
        },
        {
          field: "description",
          header: "Description",
          hidden: true,
          isKey: false,
          sort: false,
          dataAlign: "left",
          headerAlign: "left",
          customRender: this.customRenderDescription.bind(this),
          widthStyle: "address",
          apiField: "Description",
        },
        {
          field: "status",
          header: "Status",
          hidden: false,
          isKey: false,
          sort: false,
          dataAlign: "left",
          headerAlign: "left",
          widthStyle: "name",
          customRender: this.customRenderStatus.bind(this),
          apiField: "StatusValue",
        },
        {
          field: "totalAge",
          header: "Total age",
          hidden: true,
          isKey: false,
          sort: true,
          dataAlign: "right",
          headerAlign: "left",
          widthStyle: "number",
          apiField: "TotalAge",
          customRender: this.customRenderTotalAge.bind(this),
        },
        {
          field: "age",
          header: "Age of assignment",
          hidden: false,
          isKey: false,
          sort: true,
          dataAlign: "right",
          headerAlign: "left",
          widthStyle: "name",
          apiField: "Age",
          customRender: this.customRenderAge.bind(this),
        },
      ],
      settingColumn: [],
      searchTxt: this.queryParams.searchKey || "",
      isDisplayTable: true,
      refNoCheckList: {},
      headerOptions: getHeaderOptions(null),
      headerAction: getHeaderOptions(null)[0],
      isDisplayReassignPopup: false,
      recipientEmail: [],
      historyAction: this.props.history.action == "POP" ? true : false,
      OpenAccordion: true,
      selectAllWO: false,
      isAllSelectedWO: false,
      data: [],
      handleCheckBox: false,
      eligibleWO: [],
      lotStatus: null,
    };
    this.defaultNumOfColumn = this.state.builderColumn.length;
    this.checkBoxRender = this.checkBoxRender.bind(this);
  }

  componentDidMount() {
    //fetch saved filter
    this.onFetchSavedFilter();
    this.fetchLotPaidFeature();
    // this.props.history.replace(
    //   window.location.pathname + window.location.search,
    //   {}
    // );

    if (this.queryParams.skip) {
      this.fetchWorkOrdersList({
        ...this.queryParams,
        skip: this.queryParams.skip - 1,
        WODefaultConfig: true,
      });
    } else {
      this.fetchWorkOrdersList({
        take: this.state.sizePerPage,
        SentDateFrom: "",
        SentDateTo: "",
        AppointmentDateFrom: "",
        AppointmentDateTo: "",
        ResolvedDateFrom: "",
        ResolvedDateTo: "",
        ClosedDateFrom: "",
        ClosedDateTo: "",
        DueDateFrom: "",
        DueDateTo: "",
        CreatedDateFrom: "",
        CreatedDateTo: "",
        Status: this.queryParams.status ? this.queryParams.status : "",
        dueStatus: this.queryParams.dueStatus ? this.queryParams.dueStatus : "",
        AgingStatusFrom: "",
        AgingStatusTo: "",
        datetime: this.queryParams.dueStatus
          ? formatTimezoneDateTime(moment())
          : "",
        ProjectIds: "",
        RegionIds: "",
        MarketIds: "",
        LotIds: "",
        SubcontractorIds: "",
        AssignedUserIds: "",
        RegionAndMarket: "",
        WODefaultConfig: true,
      });
    }

    if (this.queryParams.take) {
      dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        Number(this.queryParams.take)
      );
    }

    // setInterval(() => {
    //   if (this.state.detectInputSearchInterVal === 2) {
    //     this.setState({detectInputSearchInterVal: 0}, () => {
    //       clearInterval(interval);
    //       this.fetchWorkOrdersList();
    //       this.search.blur();
    //     });
    //   }
    // }, 500);

    if (
      this.props.UserProfile &&
      this.props.UserProfile.userId &&
      this.props.SettingDataGridColumn
    ) {
      this.setDefaultColumn(
        this.props.UserProfile.userId,
        this.props.SettingDataGridColumn
      );
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.WorkOrderStore && nextProps.WorkOrderStore.WorkOrdersList) {
      this.setState({
        totalRecord: nextProps.WorkOrderStore.WorkOrdersList.params.totalRecord,
        currentPage: nextProps.WorkOrderStore.WorkOrdersList.params.skip,
      });

      let pagingButtons = document.getElementsByClassName("page-link");

      Array.prototype.forEach.call(pagingButtons, (el) => {
        el.blur();
      });
    }

    if (
      nextProps.UserProfile &&
      nextProps.UserProfile.userId &&
      nextProps.SettingDataGridColumn
    ) {
      this.setDefaultColumn(
        nextProps.UserProfile.userId,
        nextProps.SettingDataGridColumn
      );
    }

    if (AppSettings.clientTypeValue === "Builder") {
      const urlParams = queryString.parse(nextProps.location.search);
      if (typeof urlParams.searchKey !== "undefined") {
        this.setState({ searchTxt: urlParams.searchKey });
      } else {
        this.setState({ searchTxt: "" });
      }

      if (!urlParams.skip) {
        this.setState({
          defaultSortName: defaultParams.defaultSortName,
          defaultSortOrder: defaultParams.defaultSortOrder,
        });
      }

      if (
        urlParams.sortField &&
        urlParams.sortField !== this.state.defaultSortName
      ) {
        this.setState({ defaultSortName: urlParams.sortField });
      }

      if (
        urlParams.sortOrder &&
        urlParams.sortOrder !== this.state.defaultSortOrder
      ) {
        this.setState({ defaultSortOrder: urlParams.sortOrder });
      }
    }

    if (
      nextProps.SavedFilterValueProfile !== this.props.SavedFilterValueProfile
    ) {
      this.setState({
        selectedFilterName: nextProps.SavedFilterValueProfile.name,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.sizePerPage !== this.state.sizePerPage) {
      dispatchActionSetPageSizeReference(
        this.props.dispatch,
        TABLE_NAME,
        this.state.sizePerPage
      );
    }

    if (
      AppSettings.clientTypeValue === "Builder" &&
      !isEqual(this.props.location.search, prevProps.location.search)
    ) {
      let urlParams = queryString.parse(this.props.location.search);

      if (urlParams.skip) {
        this.fetchWorkOrdersList({
          ...urlParams,
          skip: urlParams.skip - 1,
        });
      } else {
        this.fetchWorkOrdersList({
          sortField: defaultParams.defaultSortName,
          sortOrder: defaultParams.defaultSortOrder,
          skip: urlParams.skip - 1,
          take: this.state.sizePerPage,
        });
      }
    }
  }

  componentWillUnmount() {
    this.props.dispatch({
      type: WorkOrderActionType.RESET_WORK_ORDER_LIST,
    });
  }

  fetchLotPaidFeature = () => {
    this.props.dispatch({
      type: WorkOrderActionType.GET_LOT_PAID_FEATURE,
      callback: (data, success) => {
        if (success && data.data && data.data.length > 0) {
          const newHeaderOptions = getHeaderOptions(data.data[0].lotStatus);
          const updatedColumns = [...this.state.builderColumn];
          const assignedToColumn = updatedColumns.find(
            (col) => col.field === "assignedTo"
          );
          if (assignedToColumn) {
            assignedToColumn.hidden = !data.data[0].lotStatus;
          }
          this.setState({
            lotStatus: data.data[0].lotStatus,
            headerOptions: newHeaderOptions,
            headerAction: newHeaderOptions[0],
            builderColumn: updatedColumns,
          });
        } else {
          console.log("🚀 ~ Callback failed or no data:", { data, success });
        }
      },
    });
  };

  setDefaultColumn = (userId, settingDataGridColumnProps) => {
    if (
      settingDataGridColumnProps.hasOwnProperty(userId) &&
      settingDataGridColumnProps[userId].hasOwnProperty("WO_COLUMN")
    ) {
      const selectedColumnFields = settingDataGridColumnProps[userId].WO_COLUMN;
      this.setState({ settingColumn: selectedColumnFields });
      const newColumnState = [...this.state.builderColumn];
      newColumnState.map((column) => {
        if (column.field !== "") {
          if (selectedColumnFields.indexOf(column.field) !== -1) {
            column.hidden = false;
          } else {
            column.hidden = true;
          }
        }
      });
      this.setState({ column: newColumnState });
    }
  };

  onChangeColumn = (newColumn, selectedColumnField) => {
    const { data } = this.state;
    const updatedWOs = data.map((item) => ({
      ...item,
      isWOSelected: false,
    }));
    this.setState(
      {
        isDisplayTable: false,
        refNoCheckList: {},
        data: updatedWOs,
        handleCheckBox: false,
      },
      () => {
        this.props.dispatch({
          type: BuilderActionType.SET_SELECT_COLUMN,
          params: {
            id: this.props.UserProfile.userId,
            type: "WO_COLUMN",
            data: selectedColumnField,
          },
        });

        setTimeout(() => {
          this.setState({ isDisplayTable: true });
        }, 200);
      }
    );
  };

  onFetchSubcontractorProjectSelectList = (callback) => {
    this.props.dispatch({
      type: ProjectActionType.SELECT_SUBCONTRACTOR_LIST_PROJECT_ASYNC,
      params: {
        param: { searchKey: "", selectedValue: "" },
      },
      callback,
    });
  };

  onFetchBuilderProjectSelectList = (callback, params) => {
    this.props.dispatch({
      type: ProjectActionType.SELECT_BUILDER_LIST_PROJECT_ASYNC,
      params: {
        MarketIds: params.marketIds,
        RegionIds: params.regionIds,
        TradeIds: params.tradeIds,
        LotIds: params.lotIds,
        SubcontractorIds: params.subcontractorIds,
        UserIds: params.userIds,
      },
      callback,
    });
  };

  onFetchTradeSelectList = (callback, params) => {
    this.props.dispatch({
      type: TradeActionType.SELECT_LIST_TRADE_FROM_REPORT_ASYNC,
      params: {
        RegionIds: params.regionIds,
        MarketIds: params.marketIds,
        ProjectIds: params.projectIds,
        LotIds: params.lotIds,
        SubcontractorIds: params.subcontractorIds,
        UserIds: params.userIds,
      },
      callback,
    });
  };

  onFetchRegionSelectList = (callback, params) => {
    this.props.dispatch({
      type: RegionActionType.GET_REPORT_REGION_LIST_ASYNC,
      params: {
        MarketIds: params.marketIds,
        ProjectIds: params.projectIds,
        TradeIds: params.tradeIds,
        LotIds: params.lotIds,
        SubcontractorIds: params.subcontractorIds,
        UserIds: params.userIds,
      },
      callback,
    });
  };

  onFetchMarketSelectList = (callback, params) => {
    this.props.dispatch({
      type: RegionActionType.GET_REPORT_MARKET_LIST_ASYNC,
      params: {
        RegionIds: params.regionIds,
        ProjectIds: params.projectIds,
        TradeIds: params.tradeIds,
        LotIds: params.lotIds,
        SubcontractorIds: params.subcontractorIds,
        UserIds: params.userIds,
      },
      callback,
    });
  };

  onFetchInternalUserSelectList = (callback, params) => {
    this.props.dispatch({
      type: AuthActionType.SELECT_LIST_BUILDER_USER_ASYNC,
      params: {
        RegionIds: params.regionIds,
        MarketIds: params.marketIds,
        ProjectIds: params.projectIds,
        TradeIds: params.tradeIds,
        LotIds: params.lotIds,
        SubcontractorIds: params.subcontractorIds,
      },
      callback,
    });
  };

  onFetchSubcontractorSelectList = (callback, params) => {
    this.props.dispatch({
      type: SubcontractorActionType.SEARCH_ALL_SUBCONTRACTOR_SELECT_LIST,
      params: {
        RegionIds: params.regionIds,
        MarketIds: params.marketIds,
        ProjectIds: params.projectIds,
        TradeIds: params.tradeIds,
        LotIds: params.lotIds,
        UserIds: params.userIds,
      },
      callback,
    });
  };

  onFetchLot = (callback, params) => {
    this.props.dispatch({
      type: RFSActionType.REPORT_SELECT_LIST_LOT_ASYNC,
      params: {
        RegionIds: params.regionIds,
        MarketIds: params.marketIds,
        ProjectIds: params.projectIds,
        TradeIds: params.tradeIds,
        SubcontractorIds: params.subcontractorIds,
        UserIds: params.userIds,
      },
      callback,
    });
  };

  onGetSavedFilterProfile = (params, callback) => {
    this.props.dispatch({
      type: WorkOrderActionType.GET_SAVED_FILTERED_WO_VALUE_ASYNC,
      params: {
        filterId: params.filterId,
      },
      callback,
    });
  };

  onFetchSavedFilter = () => {
    this.props.dispatch({
      type: WorkOrderActionType.GET_SAVED_FILTERED_WO_LIST_ASYNC,
      params: null,
    });
  };

  fetchWorkOrdersList(customParams = {}) {
    const {
      WorkOrderStore: {
        WorkOrdersList: { params },
      },
    } = this.props;
    if (AppSettings.clientTypeValue === "Subcontractor") {
      this.props.dispatch({
        type: WorkOrderActionType.SEARCH_SUBCONTRACTOR_WORK_ORDER_ASYNC,
        params: this.objToParams(Object.assign(params, customParams)),
      });
    } else {
      this.props.dispatch({
        type: WorkOrderActionType.SEARCH_WORK_ORDER_LIST_ASYNC,
        params: this.objToParams(Object.assign(params, customParams)),
        callback: (res) => {
          const WOList = [];
          res.items.map((items) => {
            if (
              items.status === 0 ||
              items.status === 1 ||
              items.status === 2 ||
              items.status === 6
            ) {
              WOList.push(items.refNo);
            }
          });
          const updatedWOs = res.items.map((item) => ({
            ...item,
            isWOSelected: false,
          }));
          this.setState({
            refNoCheckList: {},
            data: updatedWOs,
            handleCheckBox: false,
            eligibleWO: WOList,
            isAllSelectedWO: false,
            disableSelectAll: res.items.length > 0 ? false : true,
          });

          if (this.state.headerAction.value == "1") {
            this.onApplyAction(this.state.headerAction.value);
          }
        },
      });
    }
  }

  onSaveFilterWo = (params) => {
    this.props.dispatch({
      type: WorkOrderActionType.SAVE_FILTER_WO_ASYNC,
      params,
    });
  };

  processMultiParams = (stringParams) => {
    let params = [];

    if (stringParams === ",") {
      return stringParams;
    }

    if (stringParams) {
      const parsedParams = queryString.parse(stringParams);

      Object.keys(parsedParams).map((el) => {
        params.push(queryString.parse(parsedParams[el]).value);
      });
    }
    return params.toString();
  };

  objToParams = (obj) => {
    const selectedFieldsColumns = this.state.builderColumn.filter((item) =>
      this.state.settingColumn.includes(item.field)
    );

    const selectedFields = selectedFieldsColumns.map((item) => {
      if (item.apiField) return item.apiField.toUpperCase();
    });
    // const selectedFields = this.state.builderColumn.filter(item => this.state.settingColumn.includes(item.field)).map(item => {if(item.apiField)item.apiField.toUpperCase()});
    const urlParams = queryString.parse(this.props.location.search);

    let WODConfig;
    if (
      obj.type ||
      obj.inLot ||
      obj.RegionAndMarket ||
      obj.inAssignedUsers ||
      obj.inSubcontractors ||
      obj.inMarkets ||
      obj.inTrades ||
      obj.inRegions ||
      obj.inProjects ||
      obj.Status ||
      obj.CreatedDateTo ||
      obj.CreatedDateFrom ||
      obj.AgingStatusTo ||
      obj.AgingStatusFrom ||
      obj.dueStatus ||
      obj.SentDateFrom ||
      obj.SentDateTo ||
      obj.AppointmentDateFrom ||
      obj.assignedMode ||
      obj.AppointmentDateTo ||
      obj.ResolvedDateFrom ||
      obj.ResolvedDateTo ||
      obj.ClosedDateFrom ||
      obj.ClosedDateTo
    ) {
      WODConfig = false;
    } else {
      if (
        this.state.historyAction == true &&
        this.props.WorkOrderStore.WODefaultConfig.WODefaultConfig == true
      ) {
        WODConfig = true;
      } else if (
        this.state.historyAction == true &&
        this.props.WorkOrderStore.WODefaultConfig.WODefaultConfig == false
      ) {
        WODConfig = false;
      } else {
        if (obj.WODefaultConfig) {
          WODConfig = true;
        } else {
          WODConfig = false;
        }
      }
    }

    if (AppSettings.clientTypeValue === "Builder") {
      return {
        searchKey:
          typeof urlParams.searchKey !== "undefined"
            ? urlParams.searchKey
            : this.state.searchTxt.trim(),
        sortField: obj.sortField ? obj.sortField : this.state.defaultSortName,
        sortOrder: obj.sortOrder ? obj.sortOrder : this.state.defaultSortOrder,
        skip: obj.skip || 0,
        take: obj.take || 10,
        SentDateFrom: obj.SentDateFrom || "",
        SentDateTo: obj.SentDateTo || "",
        AppointmentDateFrom: obj.AppointmentDateFrom || "",
        AppointmentDateTo: obj.AppointmentDateTo || "",
        ResolvedDateFrom: obj.ResolvedDateFrom || "",
        ResolvedDateTo: obj.ResolvedDateTo || "",
        ClosedDateFrom: obj.ClosedDateFrom || "",
        ClosedDateTo: obj.ClosedDateTo || "",
        dueStatus: obj.dueStatus || "",
        datetime: obj.datetime || "",
        AgingStatusFrom: obj.AgingStatusFrom || "",
        AgingStatusTo: obj.AgingStatusTo || "",
        CreatedDateFrom: obj.CreatedDateFrom || "",
        CreatedDateTo: obj.CreatedDateTo || "",
        Status: obj.Status || "",
        SelectedFilterName: obj.SelectedFilterName || null,
        ProjectIds: this.processMultiParams(obj.inProjects),
        RegionIds: this.processMultiParams(obj.inRegions),
        TradeIds: this.processMultiParams(obj.inTrades),
        MarketIds: this.processMultiParams(obj.inMarkets),
        SubcontractorIds: this.processMultiParams(obj.inSubcontractors),
        AssignedUserIds: this.processMultiParams(obj.inAssignedUsers),
        AssignedMode: obj.assignedMode
          ? queryString.parse(obj.assignedMode).value
          : "",
        RegionAndMarket: obj.RegionAndMarket || "",
        LotIds: this.processMultiParams(obj.inLot),
        Type: obj.type ? queryString.parse(obj.type).value : "",
        Recipients: obj.recipients || [],
        SelectedFields: selectedFields || [],
        TimeZoneOffset: -new Date().getTimezoneOffset(),
        ItemsToRepair: this.processMultiParams(obj.inItemRepiar),
        WODefaultConfig: WODConfig,
        RFSManagedUserId: this.processMultiParams(obj.inRFSManagedBy),
      };
    }
    return {
      searchKey: this.state.searchTxt,
      sortField: obj.sortField ? obj.sortField : obj.sort.field,
      sortOrder: obj.sortOrder ? obj.sortOrder : obj.sort.order,
      skip: obj.skip || 0,
      take: obj.take || 10,
      SentDateFrom: obj.SentDateFrom || "",
      SentDateTo: obj.SentDateTo || "",
      AppointmentDateFrom: obj.AppointmentDateFrom || "",
      AppointmentDateTo: obj.AppointmentDateTo || "",
      ResolvedDateFrom: obj.ResolvedDateFrom || "",
      ResolvedDateTo: obj.ResolvedDateTo || "",
      ClosedDateFrom: obj.ClosedDateFrom || "",
      ClosedDateTo: obj.ClosedDateTo || "",
      AgingStatusFrom: obj.AgingStatusFrom || "",
      AgingStatusTo: obj.AgingStatusTo || "",
      Statuses: obj.Statuses || "",
      ProjectIds: obj.ProjectIds || "",
      dueStatus: obj.dueStatus || "",
      datetime: obj.datetime || "",
    };
  };

  onFilter = (data) => {
    const {
      WorkOrderStore: {
        WorkOrdersList: { params },
      },
    } = this.props;
    const { defaultSortName, defaultSortOrder } = this.state;
    let filterParams = Object.assign({ ...params }, data);
    delete filterParams.totalPage;
    delete filterParams.totalRecord;
    delete filterParams.sort;
    filterParams.sortField = defaultSortName;
    filterParams.sortOrder = defaultSortOrder;
    filterParams = pickBy(filterParams);
    if (AppSettings.clientTypeValue === "Subcontractor") {
      this.setState({ ...this.state, currentFilterParams: filterParams });
      this.props.dispatch({
        type: WorkOrderActionType.SEARCH_SUBCONTRACTOR_WORK_ORDER_ASYNC,
        params: this.objToParams(filterParams),
      });
    } else {
      this.props.history.push({
        search: queryString.stringify({
          ...filterParams,
          skip: 1,
        }),
      });
    }
  };

  onResetFilterName = () => {
    this.props.dispatch({
      type: WorkOrderActionType.RESET_FILTER_NAME_PROFILE,
    });
  };

  refreshList(params) {
    this.setState(
      {
        defaultSortName: params.defaultSortName,
        defaultSortOrder: params.defaultSortOrder,
        currentPage: params.currentPage,
        sizePerPage: params.sizePerPage,
      },
      () => {
        if (AppSettings.clientTypeValue === "Builder") {
          let urlParams = queryString.parse(this.props.location.search);
          urlParams["searchKey"] = this.state.searchTxt.trim();
          urlParams["sortField"] = params.defaultSortName;
          urlParams["sortOrder"] = params.defaultSortOrder;
          urlParams["skip"] = params.currentPage;
          urlParams["take"] = params.sizePerPage;
          urlParams = pickBy(urlParams);

          this.props.history.push({
            search: queryString.stringify(urlParams),
          });
        } else {
          this.fetchWorkOrdersList({
            ...this.state.currentFilterParams,
            searchKey: this.state.searchTxt.trim(),
            sortField: params.defaultSortName,
            sortOrder: params.defaultSortOrder,
            skip: params.currentPage - 1,
            take: params.sizePerPage,
          });
        }
      }
    );
  }

  onChangeInputSearch = (e) => {
    this.setState({ searchTxt: e.target.value });
  };

  onSearch(e) {
    e.preventDefault();

    if (AppSettings.clientTypeValue === "Builder") {
      let urlParams = queryString.parse(this.props.location.search);

      const { searchTxt, defaultSortName, defaultSortOrder, sizePerPage } =
        this.state;

      urlParams["searchKey"] = searchTxt.trim();
      urlParams["sortField"] = defaultSortName;
      urlParams["sortOrder"] = defaultSortOrder;
      urlParams["skip"] = 1;
      urlParams["take"] = sizePerPage;
      urlParams = pickBy(urlParams);

      this.props.history.push({
        search: queryString.stringify(urlParams),
      });
    } else {
      this.fetchWorkOrdersList({ skip: 0 });
    }
  }

  onEnter(e) {
    if (e.key === "Enter") {
      this.onSearch(e);
    }
  }

  handleExport = () => {
    const {
      WorkOrderStore: {
        WorkOrdersList: { params },
      },
    } = this.props;

    let urlParams = queryString.parse(this.props.location.search);

    let exportParams = {};

    if (urlParams.skip) {
      exportParams = { ...urlParams, skip: "", take: "" };
    } else {
      exportParams = { ...params, skip: "", take: "" };
    }

    this.props.dispatch({
      type: WorkOrderActionType.EXPORT_WORK_ORDER_LIST,
      params: this.objToParams({ ...exportParams }),
    });
  };

  onChangeHeaderAction = (event) => {
    this.setState({
      headerAction: event.value,
    });
    this.onApplyAction(event.value.value);
  };

  onApplyAction = (value) => {
    const { data } = this.state;
    if (value === 1) {
      const updatedWOs = data.map((item) => ({
        ...item,
        isWOSelected: false,
      }));
      this.setState(
        {
          data: updatedWOs,
        },
        () => {
          this.onApplyActionReassign();
        }
      );
    } else {
      const newColumnState = [...this.state.builderColumn];
      newColumnState.shift();
      const updatedWOs = data.map((item) => ({
        ...item,
        isWOSelected: false,
      }));

      this.setState({
        builderColumn: newColumnState,
        refNoCheckList: {},
        data: updatedWOs,
        handleCheckBox: false,
      });
    }
  };

  onApplyActionReassign = () => {
    const { builderColumn } = this.state;
    const checkboxColumn = {
      field: "",
      header: this.checkBoxRender(),
      hidden: false,
      isKey: false,
      sort: false,
      dataAlign: "left",
      headerAlign: "left",
      columnClassName: "td-width-50-px",
      customRender: this.customRenderCheckboxColumn.bind(this),
    };
    const newColumnState = [...builderColumn];
    if (builderColumn.length > this.defaultNumOfColumn) {
      newColumnState.shift();
      this.setState({
        column: newColumnState,
      });
    }
    newColumnState.unshift(checkboxColumn);
    this.setState({
      builderColumn: newColumnState,
    });
  };

  checkBoxRender(refNo) {
    const { data } = this.state;

    this.setState({
      isAllSelectedWO: !data.some((item) => item.isWOSelected === false),
    });

    return (
      <CheckBoxSingle
        key={this.state.isAllSelectedWO}
        checked={this.state.isAllSelectedWO}
        name="checkToSignoff"
        disabled={this.state.disableSelectAll}
        className="checkbox-default"
        onChecked={() => this.handleCheckBoxList(this.props)}
        style={{ marginTop: -7 }}
      />
    );
  }

  handleCheckBoxList = (props) => {
    const handleclick = !this.state.handleCheckBox;
    const { data } = this.state;

    if (
      props.WorkOrderStore.WorkOrdersList &&
      props.WorkOrderStore.WorkOrdersList.items &&
      props.WorkOrderStore.WorkOrdersList.items.length &&
      handleclick == true
    ) {
      const { items } = props.WorkOrderStore.WorkOrdersList;
      const checkedList = {};
      for (let i = 0; i < items.length; i++) {
        if (
          items[i].status === 0 ||
          items[i].status === 1 ||
          items[i].status === 2 ||
          items[i].status === 6
        ) {
          checkedList[items[i].refNo] = true;
        }
      }
      this.setState({
        refNoCheckList: checkedList,
        handleCheckBox: true,
      });
    } else {
      const updatedWOs = data.map((item) => ({
        ...item,
        isWOSelected: !item.isWOSelected,
      }));

      this.setState({
        refNoCheckList: {},
        handleCheckBox: false,
        data: updatedWOs,
      });
    }
  };

  popoverRight() {
    return this.state.lotStatus ? (
      <Popover id="popover-positioned-right" className="sign-off-error-popover">
        <span>At least one work order must be selected.</span>
      </Popover>
    ) : (
      <Tooltip
        id="sign_off_multiple_work_order_tooltip"
        className="in tooltip-siteone"
      >
        <span>
          This feature is currently unavailable. Please contact your Super Admin
          for access
        </span>
      </Tooltip>
    );
  }

  lotPopoverRight() {
    return (
      <Tooltip
        id="sign_off_multiple_work_order_tooltip"
        className="in tooltip-siteone"
      >
        <span>
          This feature is currently unavailable. Please contact your Super Admin
          for access
        </span>
      </Tooltip>
    );
  }

  toolTipCheckbox() {
    return (
      <Tooltip
        id="sign_off_multiple_work_order_tooltip"
        className="in tooltip-siteone"
      >
        <span>
          Only work orders with status Awaiting review/Pending/Open/Requested to
          reopen WITH a current assignee are eligible to be selected.
        </span>
      </Tooltip>
    );
  }

  onChecked = (refNo) => {
    if (!this.state.refNoCheckList[refNo]) {
      const updatedWOs = this.state.data.map((item) => ({
        ...item,
        isWOSelected: false,
      }));

      this.setState(
        {
          refNoCheckList: {
            ...this.state.refNoCheckList,
            [refNo]: !this.state.refNoCheckList[refNo],
          },
        },
        () => {
          const allValuesMatch = this.state.eligibleWO.every(
            (value) => this.state.refNoCheckList[value]
          );
          if (allValuesMatch) {
            this.setState(
              {
                data: updatedWOs,
                handleCheckBox: true,
                isAllSelectedWO: true,
              },
              () => {
                this.onApplyActionReassign();
              }
            );
          }
        }
      );
    } else {
      const { data } = this.state;
      const updatedWOs = data.map((item) => {
        if (item.refNo === refNo) {
          return {
            ...item,
            isWOSelected: true,
          };
        }
        return item; // Don't forget to return the unchanged items
      });

      let newCheckList = { ...this.state.refNoCheckList };
      delete newCheckList[refNo];
      this.setState(
        {
          refNoCheckList: newCheckList,
          data: updatedWOs,
          handleCheckBox: false,
        },
        () => {
          this.onApplyActionReassign();
        }
      );
    }
  };

  onClickGoReassignMultiplePopup = () => {
    this.state.lotStatus &&
      this.setState({
        isDisplayReassignPopup: !this.state.isDisplayReassignPopup,
      });
  };

  onSaveReassignMultiple = (user) => {
    const { refNoCheckList, data } = this.state;

    let workOrderIds = [];

    Object.keys(refNoCheckList).forEach((key) => {
      if (refNoCheckList[key]) {
        workOrderIds.push(parseInt(key));
      }
    });

    this.props.dispatch({
      type: WorkOrderActionType.REASSIGN_MULTIPLE_WORK_ORDER_ASYNC,
      params: {
        refNos: workOrderIds,
        internalUserId: user.value,
      },
      callback: () => {
        this.setState({
          isDisplayReassignPopup: false,
          headerAction: this.state.headerOptions[0],
        });
        const newColumnState = [...this.state.builderColumn];
        newColumnState.shift();
        const updatedWOs = data.map((item) => ({
          ...item,
          isWOSelected: false,
        }));
        this.setState({
          builderColumn: newColumnState,
          refNoCheckList: {},
          data: updatedWOs,
          handleCheckBox: false,
        });

        var urlParams = queryString.parse(this.props.location.search);
        this.fetchWorkOrdersList({
          ...urlParams,
          searchKey: this.state.searchTxt,
          skip: this.state.currentPage - 1,
          take: this.state.sizePerPage,
        });
      },
    });
  };

  onRemoveSavedFilterProfile = (params, callback) => {
    this.props.dispatch({
      type: WorkOrderActionType.REMOVE_SAVED_FILTERED_WO_ASYNC,
      params: {
        filterId: params.filterId,
      },
      callback,
    });
  };

  onEditSavedFilterProfile = (params, callback) => {
    this.props.dispatch({
      type: WorkOrderActionType.EDIT_SAVED_FILTERED_WO_ASYNC,
      params: {
        id: params.id,
        name: params.name,
      },
      callback,
    });
  };

  onFetchUserToReassign = () => {
    this.props.dispatch({
      type: AuthActionType.SELECT_LISTS_BUILDER_USER_ASYNC,
      params: {
        searchKey: "",
        selectedValue: "",
      },
    });
  };

  customRenderCheckboxColumn(item) {
    const { status, refNo } = item;

    const statusAllowed = [0, 1, 2, 6];

    const disabled =
      !statusAllowed.includes(status) &&
      (!item.assignedUserId || !item.subcontractorId);

    const { refNoCheckList } = this.state;

    if (disabled) {
      return (
        <OverlayTrigger placement="top" overlay={this.toolTipCheckbox()}>
          <div>
            <CheckBoxSingle
              checked={
                refNoCheckList[refNo] !== null && refNoCheckList[refNo] === true
              }
              ref={(c) => {
                this.check = c;
              }}
              name="checkToSignoff"
              disabled={disabled}
              className="checkbox-default"
              onChecked={() => this.onChecked(refNo)}
              style={{ marginTop: -7 }}
            />
          </div>
        </OverlayTrigger>
      );
    } else {
      return (
        <CheckBoxSingle
          checked={
            refNoCheckList[refNo] !== null && refNoCheckList[refNo] === true
          }
          ref={(c) => {
            this.check = c;
          }}
          name="checkToSignoff"
          disabled={disabled}
          className="checkbox-default"
          onChecked={() => this.onChecked(refNo)}
          style={{ marginTop: -7 }}
        />
      );
    }
  }

  customRenderWOIDSubcontractor(item) {
    let url = item.isPunchList
      ? `/punch-lists/${item.rfsRefNo}/punch-list-item/${item.refNo}`
      : `/request-for-services/work-order/detail/${item.rfsRefNo}/${item.refNo}`;

    if (item.rfsRefNo) {
      return <Link to={url}>{item.refNo}</Link>;
    }

    return item.refNo;
  }

  customRenderOriginalRefNoV3(item) {
    if (item.originalRefNo !== null) {
      return <span>{item.originalRefNo}</span>;
    }
    return "-";
  }

  customRenderCreatedDate(item) {
    return <span>{Moment(item.createdDate).format("MM/DD/YYYY")}</span>;
  }

  customRenderStatus(item) {
    return (
      <span>
        {AppSettings.WO_STATUS_VALUE.find((x) => x.key === item.status).value}
      </span>
    );
  }

  customRenderRFSID(item) {
    return (
      <span>
        <Link to={`/request-for-services/${item.rfsRefNo}`}>
          {item.rfsRefNo}
        </Link>
      </span>
    );
  }

  customRenderTotalAge(item) {
    if (item.status === 7) {
      return <span>-</span>;
    }
    return <span>{item.totalAge}</span>;
  }

  customRenderAge(item) {
    return renderAgeOfWorkOrder(item);
  }

  customRenderAppointmentDate(item) {
    if (item.appointmentDate) {
      return (
        <span>{Moment(item.appointmentDate).format("MM/DD/YYYY hh:mm A")}</span>
      );
    }
    return <span>-</span>;
  }

  renderWOFilter = () => {
    if (AppSettings.clientTypeValue === "Subcontractor") {
      return (
        <SubcontractorWorkOrderFilters
          onFetchProject={this.onFetchSubcontractorProjectSelectList}
          ProjectSelectList={this.props.SelectListProject}
          onFilter={this.onFilter}
        />
      );
    } else {
      return (
        <BuilderWorkOrderFilters
          onResetFilterName={this.onResetFilterName}
          onFetchProject={this.onFetchBuilderProjectSelectList}
          ProjectSelectList={this.props.SelectListProject}
          onFilter={this.onFilter}
          onFetchRegion={this.onFetchRegionSelectList}
          RegionSelectList={this.props.SelectListRegions}
          onFetchMarket={this.onFetchMarketSelectList}
          MarketSelectList={this.props.SelectListMarkets}
          RFSManagedBySelectList={this.props.builderUserList}
          SubcontractorList={this.props.SubcontractorList}
          UserList={this.props.UserList}
          onFetchInternalUserSelectList={this.onFetchInternalUserSelectList}
          builderUserList={this.props.builderUserList}
          onFetchSubcontractorSelectList={this.onFetchSubcontractorSelectList}
          sso={this.props.UserProfile.sso}
          onFetchTrade={this.onFetchTradeSelectList}
          TradeSelectList={this.props.SelectListTrade}
          onFetchLot={this.onFetchLot}
          LotSelectList={this.props.SelectListLots}
          onFetchSavedFilter={this.onFetchSavedFilter}
          SavedFilterList={this.props.SavedFilterList}
          onGetSavedFilterProfile={this.onGetSavedFilterProfile}
          SavedFilterValueProfile={this.props.SavedFilterValueProfile}
          onRemoveSavedFilterProfile={this.onRemoveSavedFilterProfile}
          onEditSavedFilterProfile={this.onEditSavedFilterProfile}
          location={this.props.location}
          onSaveFilterWO={this.onSaveFilterWo}
          idSelected={this.props.SavedFilterValueProfile.id}
        />
      );
    }
  };
  customRenderAssigned(item) {
    if (item) {
      if (item.assignedUserName) {
        return <span>{item.assignedUserName}</span>;
      }
      if (item.subcontractorName) {
        return <span>{item.subcontractorName}</span>;
      }
      return "-";
    }
    return "-";
  }

  toolTip(message) {
    return (
      <Tooltip
        className="in tooltip-siteone"
        placement="top"
        id="tooltip"
        positionLeft={0}
        arrowOffsetLeft={0}
      >
        <span
          style={{
            wordBreak: "break-all",
            maxWidth: 200,
          }}
        >
          {message}
        </span>
      </Tooltip>
    );
  }

  customRenderTitle(item) {
    return <div style={{ whiteSpace: "break-spaces" }}>{item.title}</div>;
  }

  customRenderDescription(item) {
    return <div style={{ whiteSpace: "break-spaces" }}>{item.description}</div>;
  }

  getCaret = (direction, fieldName) => {
    const { defaultSortName, defaultSortOrder } = this.state;

    if (fieldName === defaultSortName) {
      if (defaultSortOrder === "ascending") {
        return <SortCaret className="order dropup" />;
      } else {
        return <SortCaret className="order" />;
      }
    }

    return null;
  };

  onClickOnEmailButton = () => {
    this.setState({ showEmailInputBox: true });
  };

  onCloseEmailBox = () => {
    this.setState({ showEmailInputBox: false });
  };

  render() {
    //   const uniqueWO = {}; // Temporary object to store unique IDs
    //   let updatedWOList=[]
    //   if(this.props.WorkOrderStore && this.props.WorkOrderStore.WorkOrdersList.items){
    //     updatedWOList = this.props.WorkOrderStore.WorkOrdersList.items.filter(item => {
    //     if (!uniqueWO[item.id]) {
    //       uniqueWO[item.id] = true;
    //       return true;
    //     }
    //     return false;
    //   });
    // }
    var urlParams = queryString.parse(this.props.location.search);
    //   const data = updatedWOList;
    let column = [];
    const subcontractorColumn = [
      {
        field: "refNo",
        header: "WO#",
        isKey: true,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderWOIDSubcontractor.bind(this),
      },
      {
        field: "projectName",
        header: <Translate translateKey="project" capitalize />,
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
      },
      {
        field: "lotNumber",
        header: (
          <span>
            <Translate translateKey="lot" capitalize /> number
          </span>
        ),
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "left",
        headerAlign: "left",
      },
      {
        field: "lotAddress",
        header: (
          <span>
            <Translate translateKey="lot" capitalize /> address
          </span>
        ),
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
      },
      {
        field: "title",
        header: "Summary",
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderTitle.bind(this),
      },
      {
        field: "appointmentDate",
        header: "Appointment",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderAppointmentDate.bind(this),
      },
      {
        field: "description",
        header: "Description",
        hidden: false,
        isKey: false,
        sort: false,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderDescription.bind(this),
      },
      {
        field: "status",
        header: "Status",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderStatus.bind(this),
      },
      {
        field: "age",
        header: "Age of assignment",
        hidden: false,
        isKey: false,
        sort: true,
        dataAlign: "left",
        headerAlign: "left",
        customRender: this.customRenderAge.bind(this),
      },
    ];

    const {
      builderColumn,
      defaultSortName,
      defaultSortOrder,
      sizePerPage,
      totalRecord,
      currentPage,
      headerAction,
      refNoCheckList,
      isDisplayReassignPopup,
      settingColumn,
      searchTxt,
      isDisplayTable,
    } = this.state;

    if (AppSettings.clientTypeValue === "Subcontractor") {
      column = subcontractorColumn;
    } else {
      column = builderColumn;
    }

    const options = {
      defaultSortName,
      defaultSortOrder,
      sizePerPage,
      totalRecord,
      currentPage,
    };

    const customHeader = (
      <div className="table-header">
        <Row>
          <Col sm={12} md={12}>
            <Row>
              <Col sm={4}>
                <ul className="rfs-detail-table-header">
                  <li>
                    <Dropdown
                      onChange={this.onChangeHeaderAction}
                      filter={true}
                      className="filestring-dropdown filter-dropdown"
                      options={this.state.headerOptions}
                      optionLabel="text"
                      value={headerAction}
                      style={{ width: 200, margin: 0 }}
                    />
                  </li>
                  {headerAction.value === 1 &&
                    Object.keys(refNoCheckList).length === 0 && (
                      <OverlayTrigger
                        placement="right"
                        delay={{ show: 250, hide: 400 }}
                        overlay={this.popoverRight()}
                      >
                        <button className="btn btn-primary btn-info btn-siteone btn-icon">
                          Go
                        </button>
                      </OverlayTrigger>
                    )}
                  {headerAction.value === 1 &&
                    Object.keys(refNoCheckList).length !== 0 &&
                    (this.state.lotStatus ? (
                      <button
                        className="btn btn-primary btn-info btn-siteone btn-icon"
                        onClick={this.onClickGoReassignMultiplePopup}
                      >
                        Go
                      </button>
                    ) : (
                      <OverlayTrigger
                        delay={{ show: 250, hide: 400 }}
                        placement="right"
                        overlay={this.lotPopoverRight()}
                      >
                        <button className="btn btn-primary btn-info btn-siteone btn-icon">
                          Go
                        </button>
                      </OverlayTrigger>
                    ))}
                  {headerAction.value === 1 && isDisplayReassignPopup && (
                    <ReassignMultiplePopup
                      onSaveReassignPopup={this.onSaveReassignMultiple}
                      onCancelReassignPopup={
                        this.onClickGoReassignMultiplePopup
                      }
                      userSelectList={this.props.builderUserList}
                      sso={this.props.UserProfile.sso}
                      onFetchUser={this.onFetchUserToReassign}
                    />
                  )}
                </ul>
              </Col>
              <Col sm={8}>
                <div className="text-right">
                  {AppSettings.clientTypeValue === "Builder" && (
                    <Fragment>
                      <EmailButton
                        onClick={this.onClickOnEmailButton}
                        toolTipText="Email this report"
                      />
                      {this.state.showEmailInputBox && (
                        <EmailPopup
                          objToParams={this.objToParams}
                          onClose={this.onCloseEmailBox}
                          initRecipientEmails={this.state.recipientEmail}
                          workOrder={"List"}
                          clearSearch={() => {
                            this.setState({ searchTxt: "" });
                          }}
                        />
                      )}
                      <ChangeColumn
                        columnList={column}
                        settingColumn={settingColumn}
                        onChangeColumn={this.onChangeColumn}
                      />
                      <ExportButton onClick={this.handleExport} />
                    </Fragment>
                  )}
                  <div
                    className="box-search"
                    style={{ margin: 0, transform: "translateY(5px)" }}
                  >
                    <div className="input-group">
                      <input
                        type="text"
                        id="txt-search-email"
                        ref={(ref) => {
                          this.search = ref;
                        }}
                        value={searchTxt}
                        onChange={this.onChangeInputSearch}
                        className="form-control"
                        placeholder="WO #/summary"
                        onKeyPress={this.onEnter.bind(this)}
                      />
                      <span className="input-group-btn">
                        <button
                          onClick={this.onSearch.bind(this)}
                          className="btn btn-secondary"
                        >
                          <span className="fa fa-search" aria-hidden="true" />
                        </button>
                      </span>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    );

    return (
      <div className="rfs-detail add-new-work-order">
        <div className="page-title clearfix">
          <h2
            style={{ display: "inline-flex", height: 35 }}
            className="header-title-workOrder pull-left"
          >
            Work orders{" "}
            <div
              style={{
                marginLeft: 5,
                maxWidth: "85%",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {" "}
              {this.props.SelectedFilterName &&
                ` - ${this.props.SelectedFilterName}`}
            </div>
            <span>
              ({this.props.WorkOrderStore.WorkOrdersList.params.totalRecord})
            </span>
          </h2>
        </div>

        {this.renderWOFilter()}

        <TableList
          ref={(ref) => {
            this.tableList = ref;
          }}
          column={column}
          defaultParams={defaultParams}
          data={this.props.WorkOrderStore.WorkOrdersList.items}
          options={options}
          refreshPageList={this.refreshList.bind(this)}
          refreshList={this.refreshList.bind(this)}
          trClassName={(row) => checkIsOverdueWorkOrder(row)}
          customTableHeader={customHeader}
          caretRender={this.getCaret}
          isDisplayTable={isDisplayTable}
          applySkeleton={true}
          fetchWorkOrdersList={() => {
            this.fetchWorkOrdersList({
              ...urlParams,
              skip: this.queryParams.skip - 1,
            });
          }}
          openAccordion={this.state.OpenAccordion}
          lotStatus={this.state.lotStatus}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WorkOrderStore: state.WorkOrderReducer,
    SelectListProject: state.ProjectStore.ProjectList,
    SelectListRegions: state.RegionMarketStore.SelectListRegions,
    SelectListMarkets: state.RegionMarketStore.SelectListMarkets,
    SubcontractorList: state.SubcontractorStore.SubcontractorList,
    UserList: state.ProjectStore.UserSelectList,
    builderUserList: state.authReducer.builderUserList,
    UserProfile: state.UserStore.UserProfile,
    SettingDataGridColumn: state.BuilderStore.SettingDataGridColumn,
    SelectListTrade: state.TradeStore.TradeList,
    SelectListLots: state.RFSStore.SelectListLots,
    PageSizeReference: state.BuilderStore.PageSizeReference,
    SavedFilterList: state.WorkOrderReducer.SavedFilterList,
    SavedFilterValueProfile: state.WorkOrderReducer.SavedFilterValueProfile,
    SelectedFilterName: state.WorkOrderReducer.SelectedFilterName,
  };
};

export default connect(mapStateToProps)(WorkOrderList);



// WEBPACK FOOTER //
// ./src/Work-Orders/Containers/work-orders-list.js